import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthenticationService } from '../authentication.service';
@Injectable()
export class RestComboItemService {

  constructor(private http: Http, private auth: AuthenticationService) { }

  GetComboItems(FilterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_ItemCombo",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  DeleteComboItems(FilterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/DeleteComboMaster",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetComboMasterById(FilterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/GetComboMasterById",
        FilterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveItem(FilterBarcode: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Save_ItemCombo",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  UpdateItem(FilterBarcode: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_ComboItem",
        FilterBarcode,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getNextComboItemId(LocationId: number) {
    return this.http
      .get(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Next_ItemId?LocationId=" + LocationId,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/restaurant/rest-combo-item.service.ts